import { useSessionData } from '../useSessionData';

const HEALTH_PROFILE_SESSION_CONTEXT_KEY = 'HEALTH_PROFILE_SESSION_CONTEXT_KEY';
const VERSION = 'V1';

export interface HealthProfileSessionData {
  hasSeenForm: boolean;
}

const emptyHealthProfileData: HealthProfileSessionData = {
  hasSeenForm: false,
};

export function useHealthProfileSessionData() {
  const { data, setData, isLoading } = useSessionData(`${HEALTH_PROFILE_SESSION_CONTEXT_KEY}.${VERSION}`);
  let dataObj = data ? (JSON.parse(data) as HealthProfileSessionData) : emptyHealthProfileData;

  const setHealthProfileSessionData = (newContext: HealthProfileSessionData) => {
    setData(newContext);
    dataObj = newContext;
  };

  return {
    healthProfileSessionData: dataObj,
    setHealthProfileSessionData,
    isLoadingSessionData: isLoading,
  };
}
